// import React from 'react';

// const AuthCard = ({ title, subtitle, children }) => {
//   return (
//     <div className="max-w-md mx-auto text-center">
//       {/* The change is in the line below */}
//       <div className="backdrop-blur-sm bg-gray-900/70 border border-gray-700 rounded-2xl p-12 shadow-2xl">
//         <div className="w-16 h-16 mx-auto mb-8 relative">
//           <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/20 to-yellow-600/20 rounded-full blur-xl"></div>
//           <div className="relative w-full h-full bg-gray-800/50 rounded-full flex items-center justify-center border border-gray-700">
//             <svg className="w-8 h-8 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
//             </svg>
//           </div>
//         </div>
        
//         <h2 className="text-2xl font-light text-white mb-3">
//           {title}
//         </h2>
//         <p className="text-gray-400 mb-8 font-light leading-relaxed">
//           {subtitle}
//         </p>
        
//         <div>
//           {children}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthCard;


import React from 'react';

const AuthCard = ({ children }) => {
  return (
    <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-amber-400/15 bg-[#0f172a]/95 shadow-[0_24px_80px_rgba(0,0,0,0.55),0_0_0_1px_rgba(251,191,36,0.06)] backdrop-blur-xl">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(251,191,36,0.08)_0%,transparent_45%)]" />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_80%_100%,rgba(251,191,36,0.04)_0%,transparent_40%)]" />
      <div
        className="pointer-events-none absolute inset-0 z-0 opacity-[0.06]"
        style={{
          backgroundImage: "url(/img/Logo_Directory/Gold_Yellow.svg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      <div className="relative z-10">{children}</div>
    </div>
  );
};
// public/img/Logo_Directory/Gold_Yellow.svg

export default AuthCard;
